import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Accompagnement from "@/pages/Accompagnement";
import APropos from "@/pages/APropos";
import Lieux from "@/pages/Lieux";
import Contact from "@/pages/Contact";

const SITE_URL = "https://decoded-brain.emergent.host";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute(
        "href",
        `${SITE_URL}${location.pathname === "/" ? "/" : location.pathname}`
      );
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accompagnement" element={<Accompagnement />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/lieux" element={<Lieux />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
